import { environment } from '../../environments/environment';

// TODO: [ddd-cleanup @platform-xp] - this is used only by shared/models/s3File.model, which should be duplicated per domain.
export const userBrandVisibilityFileUrl =
    environment.USER_BRAND_VISIBILITY_FILE_URL ||
    'https://s3.eu-central-1.amazonaws.com/fashioncloud-static-data/frontend/brands-visibility-testing.json';
export const productCategoriesFileUrl =
    environment.PRODUCT_CATEGORIES_FILE_URL ||
    'https://s3.eu-central-1.amazonaws.com/fashioncloud-static-data/frontend/product-categories-testing.json';
export const discountBrandsFileUrl =
    environment.DISCOUNT_BRANDS_FILE_URL ||
    'https://s3.eu-central-1.amazonaws.com/fashioncloud-static-data/frontend/discount-brands-testing.json';
export const organizationFeatureFlagsFileUrl =
    environment.ORGANIZATION_FEATURE_FLAGS_FILE_URL ||
    'https://s3.eu-central-1.amazonaws.com/fashioncloud-static-data/frontend/organization-feature-flags-testing.json';
export const categoriesConfigurationFileUrl =
    environment.CATEGORIES_CONFIGURATION_FILE_URL ||
    'https://s3.eu-central-1.amazonaws.com/fashioncloud-static-data/frontend/categories-configuration-testing.json';
